enum PathEnum {
    PASSWORD_SET = "/ui/pwd/set",
    PASSWORD_OTP = "/ui/pwd/set/otp",
    PASSWORD_RESULT = "/ui/pwd/set/result",
    PASSWORD_ERROR = "/ui/pwd/set/error",
    PASSWORD_PHONE = "/ui/pwd/set/phone",
    PASSWORD_VERIFY_PHONE = "/ui/pwd/set/verifyPhone",
    LOGIN = "/login",
    LOGIN_OTP = "/login/otp",
    LOGIN_CONSENT = "/login/consent",
    LOGIN_ERROR = "/login/error",
    LOGIN_PHONE = "/login/phone",
    LOGIN_VERIFY_PHONE = "/login/verifyPhone",
    CONTRACT_WITHDRAWAL = "/contract-withdrawal",
    CONTRACT_WITHDRAWAL_EMAIL = "/contract-withdrawal/email",
    CONTRACT_WITHDRAWAL_ERROR = "/contract-withdrawal/error",
    CONTRACT_WITHDRAWAL_OTP = "/contract-withdrawal/otp",
    CONTRACT_WITHDRAWAL_PHONE = "/contract-withdrawal/phone",
    CONTRACT_WITHDRAWAL_RESULT = "/contract-withdrawal/result"
}

export default PathEnum;
